import React, { useEffect, useState } from "react";
import { importPhotoFromBd, listBdPhotos } from "../../../api/minisite";

export default function ExistingPhotoPicker({
  clientId,
  onChange,
  ariaLabelSuffix = "comme photo hero",
}) {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyFilename, setBusyFilename] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;

    async function loadPhotos() {
      setLoading(true);
      setError(null);
      try {
        const items = await listBdPhotos(clientId);
        if (alive) setPhotos(items || []);
      } catch (err) {
        if (alive) setError(err?.response?.data?.detail || err.message);
      } finally {
        if (alive) setLoading(false);
      }
    }

    loadPhotos();
    return () => {
      alive = false;
    };
  }, [clientId]);

  const pickPhoto = async (filename) => {
    setBusyFilename(filename);
    setError(null);
    try {
      const result = await importPhotoFromBd(clientId, filename);
      onChange(result.filename);
    } catch (err) {
      setError(err?.response?.data?.detail || err.message);
    } finally {
      setBusyFilename(null);
    }
  };

  if (loading) return null;

  if (photos.length === 0) {
    return (
      <div style={{ marginTop: 12, fontSize: 13, color: "#666" }}>
        Aucune photo déjà uploadée dans ce dossier.
        {error && <div style={{ color: "red", fontSize: 12, marginTop: 8 }}>{error}</div>}
      </div>
    );
  }

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>
        Choisir parmi les photos déjà uploadées
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {photos.map((photo) => {
          const disabled = busyFilename !== null;
          const busy = busyFilename === photo.filename;
          return (
            <button
              key={photo.filename}
              type="button"
              aria-label={`Utiliser ${photo.filename} ${ariaLabelSuffix}`}
              onClick={() => pickPhoto(photo.filename)}
              disabled={disabled}
              className="border rounded overflow-hidden bg-white text-left hover:bg-gray-50 disabled:cursor-not-allowed"
              style={{ opacity: busy ? 0.55 : 1 }}
            >
              <span className="aspect-square bg-gray-100 flex items-center justify-center">
                <img
                  src={photo.url}
                  alt={photo.filename}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </span>
              <span className="block p-2 text-xs truncate" title={photo.filename}>
                {busy ? "Import..." : photo.filename}
              </span>
            </button>
          );
        })}
      </div>
      {error && <div style={{ color: "red", fontSize: 12, marginTop: 8 }}>{error}</div>}
    </div>
  );
}
